import React from 'react';
import './Tabs.css';

export const TabsDesc = ({ selectedTab, onTabChange }) => {
  return (
    <div className="tabs">
      <button
        className={selectedTab === 'to_post' ? 'active' : ''}
        onClick={() => onTabChange('to_post')}
      >
        发布到classpass
      </button>
      <button
        className={selectedTab === 'posted' ? 'active' : ''}
        onClick={() => onTabChange('posted')}
      >
        从classpass下架
      </button>
    </div>
  );
};

const TabsClass = ({ selectedTab, onTabChange }) => {
  return (
    <div className="tabs">
      <button
        className={selectedTab === 'post' ? 'active' : ''}
        onClick={() => onTabChange('post')}
      >
        发布课程
      </button>
      <button
        className={selectedTab === 'update' ? 'active' : ''}
        onClick={() => onTabChange('update')}
      >
        已发布课程
      </button>
    </div>
  );
};

export default TabsClass;


